import React from "react";
import NavbarEntite from "../components/NavbarEntite";

const Layout = (props) => {
  return (
    <div className="min-h-screen">
      <NavbarEntite />
      <div className="pt-10">{props.children}</div>
    </div>
  );
};

export default Layout;
